import { useQuery, useMutation } from '@tanstack/react-query';
import client from '../api/client';
import useBetsStore from '../stores/betsStore';
import toast from 'react-hot-toast';

export function useBets() {
  const { selections, stake, clear } = useBetsStore();
  const isAuthenticated = !!localStorage.getItem('jwt_token');

  const historyQuery = useQuery({
    queryKey: ['bets'],
    queryFn: async () => {
      const { data } = await client.get('/bets', { params: { limit: 20, offset: 0 } });
      return data;
    },
    staleTime: 10000,
    enabled: isAuthenticated,
  });

  const placeBetMutation = useMutation({
    mutationFn: async () => {
      if (selections.length === 0) throw new Error('Nenhuma seleção');
      const selection = selections[0];
      const { data } = await client.post(
        '/bets',
        { market_id: selection.market_id, selection: selection.selection, stake },
        { headers: { 'Idempotency-Key': crypto.randomUUID() } }
      );
      return data;
    },
    onSuccess: (data) => {
      toast.success(`Aposta aceita! #${data.bet_id}`);
      clear();
    },
    onError: (err) => {
      const msg = err.response?.data?.error?.message || 'Erro ao apostar';
      toast.error(msg);
    },
  });

  return { historyQuery, placeBetMutation, selections, stake };
}
